// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, put, post, del } from "./api_client";
import { AlertSubscription, IAlertSubscription } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function list(): ApiResult<AlertSubscription[]> {
	return get<IAlertSubscription[]>(`/api/alertsubscription`).then(result => result === undefined ? undefined : result.map(o => new AlertSubscription(o)));
}

export async function create(body: AlertSubscription): ApiResult<AlertSubscription> {
	return post<IAlertSubscription>(`/api/alertsubscription`, body).then(result => result === undefined ? undefined :  new AlertSubscription(result));
}

export async function update(id?: string, body?: AlertSubscription): ApiResult<AlertSubscription> {
	return put<IAlertSubscription>(`/api/alertsubscription/${ id }`, body).then(result => result === undefined ? undefined :  new AlertSubscription(result));
}

export async function deleteSubscription(id?: string): ApiResult<undefined> {
	return del(`/api/alertsubscription/${ id }`);
}
